/**
 * @param scope 类名
 * @returns 返回空间名-类名
 */
export const getPrefixCls = (scope?: string) => {
  if (!scope) return "vac";
  return `vac-${scope}`;
};

export const getFormilyPrefixCls = (scope?: string) => {
  if (!scope) return "vac-f";
  return `vac-f-${scope}`;
};
